// extracted by mini-css-extract-plugin
export default {"main":"Login_main__MApKF","cta-form":"Login_cta-form__9dPIy","btn--form":"Login_btn--form__8CP9k"};